
export const LANDING = '/';
export const SIGN_UP = '/signup';
export const LOGIN = '/login';
export const TASKS = '/tasks';
export const ANALYTICS = '/analytics';
export const SETTINGS = '/settings';